import { socialLabelOf, socialLinkName, type SocialLink } from "@fusiqo/vozqi-shared";
import { SocialMark } from "../ui/social-mark";
import { RowChevron } from "./row-chevron";

/**
 * «SÍGUENOS»: the networks the business set, Instagram, Facebook,
 * TikTok, each its mark, its handle and the chevron of a row that opens,
 * opening the network in a new tab. Its name says whose it is and keeps the
 * handle, so a voice command that says what it reads still finds it.
 * The business's own word, so it sits in the rail with the hours and never
 * beside «Pedir servicio» nor among the verified signals. Nothing when it set none.
 */
export function ProfileSocial({ social, business }: { social: SocialLink[]; business: string }) {
  if (social.length === 0) return null;
  return (
    <section className="profile-card" aria-labelledby="profile-social">
      <h2 id="profile-social" className="profile-card-title">
        Síguenos
      </h2>
      <ul className="profile-social">
        {social.map((link) => (
          <li key={link.network}>
            <a
              className={`profile-social-link profile-social-link--${link.network}`}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={socialLinkName(link, business)}
            >
              <SocialMark network={link.network} />
              <span className="profile-social-handle">{socialLabelOf(link.network, link.handle)}</span>
              <RowChevron className="profile-social-chevron" />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
